/**
 * ChallengeContainerV2 - Main layout container for challenge content
 *
 * Provides responsive layout with:
 * - Centered content on all screen sizes
 * - Max-width constraint for readability
 * - Proper padding and spacing
 */

import { memo } from 'react'

const ChallengeContainerV2 = memo(({ children }) => {
  return (
    <main className="flex-1 min-h-0 overflow-y-auto">
      <div className="w-full max-w-4xl mx-auto px-2 sm:px-6 lg:px-8 py-4 sm:py-6">{children}</div>
    </main>
  )
})

ChallengeContainerV2.displayName = 'ChallengeContainerV2'

export default ChallengeContainerV2
